import { atom } from "recoil";

export const selRegionYearState = atom({
    key: 'selectedYear',
    default: '1'
});

export const poiVisibleState = atom({
    key: 'poiVisible',
    default: {
        zeroPoIData: false,
        wipPoIData : false,
        isPoiData: false,
        poiUpdatedDate: ''
    }
});


export const selectedCardState = atom<{
    mbpData: boolean;
    EhData: boolean;
    cTVData: boolean;
    poiData: boolean;
}>({
    key: 'selectedCardType',
    default: { mbpData: false, EhData: false, cTVData: false, poiData: false }
});

export const expandedHeaderBreakdownTableState = atom<number | null>({
    key: 'expandedHeaderBreakdownTableState', 
    default: null
});

export const selectedBreakDownState = atom ({
    key : 'selectedBreakDown',
    default: 'By State'
})


export const selectedBreakDownIndexState = atom ({
    key : 'selectedBreakDownIndexState',
    default: 0
})

export const selectedDashboardStackRankKeysState = atom<any[]>({
    key: 'selectedDashboardStackRankKeysState',
    default: ['EH']
})

export const selectedChilddashboardState = atom({
    key: 'selectedChild',
    default: { 'PoI': 0, 'CTV': 0, 'EH': 0}
});

export const kpiValuesLoadedState = atom({
    key: 'kpiValuesLoaded',
    default: false
});

export const buttonStateRetainedState = atom<{
    EhData: [number, boolean] | null;
    cTVData: [number, boolean] | null;
    poiData: [number, boolean] | null;
}>({
    key: 'buttonStateRetained',
    default: {
        EhData: null,
        cTVData: null,
        poiData: null,
    }
});

export const breakdownTableSortState = atom<{
    EhData: { sorting: boolean; buttonState: [number, boolean] };
    cTVData: { sorting: boolean; buttonState: [number, boolean] };
    poiData: { sorting: boolean; buttonState: [number, boolean] };
}>({
    key: 'breakdownTableSortState',
    default: {
        EhData: { sorting: false, buttonState: [2, false] },
        cTVData: { sorting: false, buttonState: [2, false] },
        poiData: { sorting: false, buttonState: [2, false] },
    }
});